export const IS_PANEL_SIDEBAR_SHOWN = 'is-panel-sidebar-shown';
export const IS_PANEL_SIDEBAR_HIDDEN = 'is-panel-sidebar-hidden';
